<div
  id="company-users"
  class="settings-page-container"
  rvSpinner="company-users-list"
  [rvShowSpinner]="users.loadingItems"
>
  <div class="settings-page-body">
    <div
      class="tw-flex tw-flex-col tw-gap-4 xl:!tw-flex-row button-toolbar-md-folded"
    >
      <search-filter
        #searchFilter
        class="w-100"
        [filterConfig]="filterConfig"
        [search]="search"
        [doSearch]="users.doSearch"
      ></search-filter>
      <div class="button-toolbar tw-flex" *requireRole="'ua sa'">
        <button matButton="outlined" type="button" (click)="exportUsers()">
          Export
        </button>
        <a
          id="userAddButton"
          class="btn btn-primary btn-toolbar-wide"
          uiSref="apps.user.add"
        >
          Add User
        </a>
      </div>
    </div>

    @if (users.items.list.length > 0) {
      <!-- List of Users -->
      <div
        class="settings-page-section scrollable-list tw-mt-8 tw-max-h-[calc(100vh-320px)]"
        scrollingList
        (scrollEndEvent)="users.load()"
      >
        <table
          mat-table
          id="company-users-list"
          [dataSource]="users.items.list"
        >
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="tw-font-medium tw-text-gray-900"
            >
              <div class="tw-flex tw-items-center tw-gap-4">
                <initials-badge
                  size="32"
                  [name]="element.firstName + ' ' + element.lastName"
                ></initials-badge>
                <span class="tw-font-medium"
                  >{{ element.firstName }} {{ element.lastName }}</span
                >
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let element" class="tw-text-gray-700">
              {{ element.email }}
            </td>
          </ng-container>

          <ng-container matColumnDef="joined">
            <th mat-header-cell *matHeaderCellDef>Joined</th>
            <td mat-cell *matCellDef="let element" class="tw-text-gray-700">
              {{ element.termsAcceptanceDate | date: 'MMM d, yyyy' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="lastActive">
            <th mat-header-cell *matHeaderCellDef>Last Active</th>
            <td mat-cell *matCellDef="let element" class="tw-text-gray-700">
              {{ element.lastLogin | timeAgo }}
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr
            mat-row
            tabindex="0"
            class="tw-cursor-pointer"
            (keyup.enter)="goToUserDetails(row.username)"
            (click)="goToUserDetails(row.username)"
            *matRowDef="let row; columns: displayedColumns"
          ></tr>
        </table>
      </div>
    } @else if (users.items.list.length === 0 && !users.loadingItems) {
      <!-- Empty List -->
      @if (search.query) {
        <no-results (action)="searchFilter.reset()"></no-results>
      } @else {
        <div class="empty-list">
          <div class="empty-list__icon">
            <mat-icon svgIcon="empty-user-list" class="extra-large"></mat-icon>
          </div>
          <p class="empty-list__text">Add team members</p>
          <p class="empty-list__subtext">
            You haven’t added any users to this company yet. Admins can add
            company users and manage roles and permissions.
          </p>
        </div>
      }
    }
  </div>
</div>
